import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import DynamicComponent from '../Components/DynamicComponent';
import { connect, Provider } from 'react-redux';
import { get } from '../Services/http';
import { load as loadConfigPresets, close as closeConfig } from '../Actions/ProductConfigurator.action';
import ConfigButton from '../Components/ConfigButton';
import { googleAnalytics } from "../Services/googleAnalytics";
import convertUnit from "../Services/conversions";
import {renderReact,store} from '../index'

class ConfigButtonContainer extends Component {
  constructor(props) {
    super(props);
    this.buttonRef = React.createRef();

    this.openConfigurator = this.openConfigurator.bind(this);
  }
  getStackedItem(props) {
    const { quantityPriceList, baseunit, factorKg } = props.stackedPrices;
    // let quantityUnit = convertUnit(
    //   props.baseUnitQuantity,
    //   props.quantitySelector.baseUnit,
    //   props.quantitySelector.quantityUnits.find((e) => e.unit == "kg")
    // );
    let quantityUnit = props.totalWeight;


    if (quantityPriceList && quantityPriceList.length) {
      let stackedItem;

      for (let priceListItem of quantityPriceList) {
        let quantity = priceListItem.quantity;

        // if (baseunit !== "kg") {
        //   quantity = priceListItem.quantity / factorKg;
        // }

        if (quantityUnit < quantity) {
          // stackedItem = priceListItem;
          break;
        }
        stackedItem = priceListItem;
      }
      return stackedItem ? stackedItem : quantityPriceList[0];
    }

    return null;
  }

  renderGoogleAnalytics(props) {
    return {
      event: "product-view",
      ecommerce: {
        detail: {
          products: [
            {
              name: props.articleName,
              id: props.axItemId,
              category: props.breadcrumbs,
              campaignProduct: props.isCampaignProduct,
            },
          ],
        },
      },
    };
  }

  openConfigurator(elementId, articleNumber, orderRow, presets,isSavedCart,cartId) {
    const parentElement = document.getElementById(elementId);
    parentElement.classList.add('configurator--open');
    var doc = document.querySelector('.productrow[data-articleNumber="' + articleNumber + '"]');
    if (doc != null) {
      var activeRow = document.querySelector('.productrow.active');
      if (activeRow) {
        activeRow.classList.remove('active');
      }
      doc.classList.add('active');
    }

    ReactDOM.unmountComponentAtNode(parentElement);

    get(`/api/configurator/load?articleNumber=${encodeURIComponent(articleNumber)}&orderRow=${orderRow ? orderRow : '00000000-0000-0000-0000-000000000000'}&savedCartId=${cartId ? cartId : '00000000-0000-0000-0000-000000000000'}`)
      .then(response => response.json())
      .then(config => {
        googleAnalytics(this.renderGoogleAnalytics(config));
        this.props.loadPresets(presets, config, articleNumber);

        const ProductConfigurator = DynamicComponent({
          loader: () => import('../Containers/ProductConfigurator.container')
        });

        renderReact(
          <Provider store={store}>
            <ProductConfigurator modal={true} articleNumber={articleNumber} orderRow={orderRow} isSavedCart={isSavedCart} cartId={cartId} />
          </Provider>,
          parentElement
        );
      });
  }

  render() {
    
    return (
      <ConfigButton {...this.props}
        onClick={(articleNumber, orderRow, presets,isSavedCart,cartId) => this.openConfigurator('configurator-modal', articleNumber, orderRow, presets,isSavedCart,cartId)} />
    );
  }
}

const mapStateToProps = state => {
  return {}
}

const mapDispatchToProps = dispatch => {
  return {
    loadConfigurator: (articleNumber, state) => {
      dispatch(loadConfigurator({
        articleNumber,
        state
      }));
    },
    loadPresets: (presets, config, articleNumber) => {
      dispatch(loadConfigPresets(presets, config, articleNumber));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfigButtonContainer);